import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { AuthContext } from "../../cognito/AuthProvider";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Nav from "../../hooks/Nav";
import BreadCrumb from "../../tailwindUI/BreadCrumb";
import {
  CardItem,
  CardSection,
  CardSectionSkeleton,
  CardSectionWrapper,
} from "../../tailwindUI/CardSection";
import { useCampaign } from "../../hooks/collectionManager/useCampaign";
import Table from "../../tailwindUI/Table";
import PrimaryButton from "../../tailwindUI/PrimaryButton";
import SecondaryLoader from "../../hooks/SecondaryLoader";
import EmptyState from "../../tailwindUI/EmptyState";
import { NotificationSlide } from "./NotificationsSlide";
import Badge from "../../tailwindUI/Badge";

const roadMap = [
  { name: "Campañas", url: "/collecting-manager", current: false },
  {
    name: "Detalle de campaña",
    url: "/collecting-manager/view",
    current: true,
  },
];

export function ViewCampaing() {
  const history = useHistory();
  const { id } = useParams();
  const { user } = React.useContext(AuthContext);

  const {
    campaign,
    generateCampaignLinks,
    generateCampaignNotifications,
    isLoading,
    isPending,
    refresh,
  } = useCampaign({
    campaignId: id,
  });

  return (
    <>
      {isPending && <SecondaryLoader />}
      <div className="w-full">
        <Nav user={user}>
          <div className="w-full">
            <Link to="/collecting-manager">
              <span className="text-2xl text-white font-bold flex items-center cursor-pointer">
                <span className="text-white opacity-50 text-4xl mr-2">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </span>
                <span className="text-lg pr-1">Campañas</span>
              </span>
            </Link>
          </div>
        </Nav>
      </div>

      <div className="min-h-full md:min-h-[calc(100vh-4rem)]">
        <div className="w-full px-4 pt-4">
          <div className="w-full mt-20 md:mt-4 mb-4 md:mb-0">
            <BreadCrumb roadMap={roadMap} />
          </div>
          <div className="flex w-full items-center justify-between">
            <div className="hidden md:flex text-3xl text-v2-input-text font-bold mt-5">
              <a>
                <FontAwesomeIcon
                  className="cursor-pointer"
                  icon={faArrowLeft}
                  onClick={() => history.goBack()}
                />
              </a>
              <span className="pl-4 w-full">Detalle de campaña</span>
            </div>
            <div className="space-x-4">
              <PrimaryButton
                onClick={generateCampaignLinks}
                disabled={!campaign?.campaign_id}
              >
                Generar links de pago
              </PrimaryButton>

              <PrimaryButton
                onClick={generateCampaignNotifications}
                disabled={!campaign?.campaign_id}
              >
                Generar Notificaciones
              </PrimaryButton>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-0 md:py-4 mb-16 lg:mb-8">
          <CardSectionWrapper>
            {isLoading ? (
              <>
                <CardSectionSkeleton title="Campaña" />
                <CardSectionSkeleton title="Notificaciones" />
              </>
            ) : (
              <>
                <CardSection title="Campaña" status={campaign?.status}>
                  <CardItem label="Fecha" value={campaign?.created} />
                  <CardItem
                    label="Última actualización"
                    value={campaign?.updated}
                  />
                  <CardItem
                    label="Registros totales"
                    value={campaign?.total_registers}
                  />
                  <CardItem
                    label="Links de pago"
                    value={<Badge text={campaign?.payment_links_status} />}
                  />
                  <CardItem label="Detalles">
                    <NotificationSlide
                      campaignId={campaign?.campaign_id}
                      disabled={campaign?.notifications_status !== "processed"}
                      refresh={refresh}
                    />
                  </CardItem>
                  <CardItem
                    label="Notificaciones"
                    value={<Badge text={campaign?.notifications_status} />}
                  />
                </CardSection>

                <CardSection
                  title="Notificaciones"
                  status={campaign?.notifications_status}
                >
                  <CardItem className="col-span-full sm:col-span-full">
                    {campaign?.notifications_dates &&
                    campaign?.notifications_dates.length > 0 ? (
                      <Table
                        title="Fechas de notificaciones"
                        data={campaign?.notifications_dates}
                        columns={[
                          { heading: "Fecha", value: "date", main: true },
                          {
                            heading: "Estado",
                            value: "status",
                            badge: true,
                            align: "center",
                          },
                        ]}
                      />
                    ) : (
                      <EmptyState
                        className="border-none py-0"
                        title="No hay notificaciones disponibles"
                      />
                    )}
                  </CardItem>
                </CardSection>
              </>
            )}
          </CardSectionWrapper>
        </div>
      </div>
    </>
  );
}
